import React from 'react';
import { Route } from 'react-router'

import IntelligenceMapInMoment from './intelligenceMapInMoment'
import IntelligenceMapInTimeRange from './intelligenceMapInTimeRange'

import styles from './intelligenceMap.module.scss'

const IntelligenceMap = () => {
  return (
    <div className={styles.intelligenceMap}>
      <Route exact path='/cars/:id/intimerange' component={IntelligenceMapInTimeRange} />
 {/*      <Route exact path={['/cars/:id/inmoment', '/cars/:id']} component={IntelligenceMapInMoment} /> */}
    </div>
  )
}

export default React.memo(IntelligenceMap)
